<div class="cx-modal-container">
  <div class="cx-modal-content">
    <div class="cx-dialog-header modal-header">
      <div class="cx-dialog-title modal-title">
        <span>{{ "savedCart.createDeliveryGroups" | cxTranslate }}</span>
      </div>
      <button
        type="button"
        class="close"
        aria-label="Close"
        (click)="closeModal('close')"
      >
        <i class="material-icons">close</i>
      </button>
    </div>
    <div class="cx-dialog-body modal-body group-modal-body">
      <div class="container">
        <div class="row desc-text">
          <span> {{ "savedCart.groupMsg" | cxTranslate }} </span>
        </div>
        <div *ngIf="showError" class="row error-msg-holder mt-3">
          <div class="error-msg-box">
            <i class="material-icons mr-2">report</i>
            <span class="bold-text mr-2"
              >{{ "savedCart.error" | cxTranslate }}</span
            >
            <span *ngIf="errors && errors.type == 101"
              >{{ "savedCart.enterdeliveryGroup" | cxTranslate }}</span
            >
            <span *ngIf="errors && errors.type == 103"
              >{{ "savedCart.requestedDateMsg" | cxTranslate }}</span
            >
            <span *ngIf="errors && errors.type == 104"
              >{{ "savedCart.diffShipLocations" | cxTranslate }}</span
            >
          </div>
        </div>
        <div class="row group-header mt-3">
          <div class="col-3 pr-0">
            {{ "savedCart.partNumber" | cxTranslate }}
          </div>
          <div class="col-4 p-0">
            {{ "savedCart.promisedShipDate" | cxTranslate }}
          </div>
          <div class="col-3 p-0">
            {{ "savedCart.availabilityAt" | cxTranslate }}
          </div>
          <div class="col-2 pl-0">
            {{ "savedCart.deliveryGroup" | cxTranslate }}
          </div>
        </div>
        <div class="group-content-holder">
          <div
            class="row group-content"
            *ngFor="let entry of _items; let i = index"
          >
            <div class="col-3 pr-2">
              <span>{{ entry.product.code }}</span>
            </div>
            <div class="col-4 pl-0 position-static">
              <vs-date-picker
                (selectedDate)="onDateChange($event, i)"
                [defaultDate]="entry?.assignedShipDate"
                [min]="minDate"
                [filterWeekend]="filterWeekend"
                [ngClass]="entry?.quoteCartEntryType ? 'disabled' : ''"
                [showError]="errors?.type == 103 && isEntryHasError(i)"
              >
              </vs-date-picker>
            </div>
            <div class="col-3 pl-0">
              <span>{{ entry.selectedLegalEntity?.salesOrganization }}</span>
            </div>
            <div class="col-2 pl-0">
              <div class="vs-text-field">
                <input
                  type="text"
                  onkeypress="return (event.charCode == 8 || event.charCode == 0 || event.charCode == 13) ? null : event.charCode >= 48 && event.charCode <= 57"
                  maxlength="3"
                  class="group-input"
                  [(ngModel)]="entry.deliveryGroupNumber"
                  [class.error]="(!entry.deliveryGroupNumber && showError) || (errors && isEntryHasError(i))"
                />
                <!-- <label class="error" *ngIf="!entry.deliveryGroup && showError">
                        enter delivery group
                    </label> -->
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="modal-footer mt-3">
      <button cxAutoFocus class="vs-text-btn" (click)="closeModal('close')">
        {{ "savedCart.cancel" | cxTranslate }}
      </button>
      <button
        class="vs-primary-btn"
        (click)="closeModal('save-delivery-groups')"
      >
        <span>{{ "savedCart.save" | cxTranslate }}</span>
      </button>
    </div>
  </div>
</div>
